import TennisRatingConverter from './TennisRatingConverter';

export type { PageProps } from './TennisRatingConverter';
export { FAQS } from './faqs';
export default TennisRatingConverter;
